import "antd/es/drawer/style";
import _Drawer from "antd/es/drawer";
import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "trigger", "onVisibleChange", "drawerProps", "onFinish", "submitTimeout", "title", "width", "visible"];
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import useMergedState from "rc-util/es/hooks/useMergedState";
import { createPortal } from 'react-dom';
import { BaseForm } from '../../BaseForm';
import { noteOnce } from "rc-util/es/warning";
import merge from 'lodash/merge';
import { useRefFunction } from '@ant-design/pro-utils';

function DrawerForm(_ref) {
  var _context$locale3, _context$locale3$Moda, _context$locale4, _context$locale4$Moda;

  var children = _ref.children,
      trigger = _ref.trigger,
      onVisibleChange = _ref.onVisibleChange,
      drawerProps = _ref.drawerProps,
      onFinish = _ref.onFinish,
      submitTimeout = _ref.submitTimeout,
      title = _ref.title,
      width = _ref.width,
      propVisible = _ref.visible,
      rest = _objectWithoutProperties(_ref, _excluded);

  noteOnce( // eslint-disable-next-line @typescript-eslint/dot-notation
  !rest['footer'] || !(drawerProps === null || drawerProps === void 0 ? void 0 : drawerProps.footer), 'DrawerForm 是一个 ProForm 的特殊布局，如果想自定义按钮，请使用 submit.render 自定义。');
  var context = useContext(_ConfigProvider.ConfigContext);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      forceUpdate = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useMergedState = useMergedState(!!propVisible, {
    value: propVisible,
    onChange: onVisibleChange
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      visible = _useMergedState2[0],
      setVisible = _useMergedState2[1];

  var footerRef = useRef(null);
  var footerDomRef = useCallback(function (element) {
    if (footerRef.current === null && element) {
      forceUpdate([]);
    }

    footerRef.current = element;
  }, []);
  useEffect(function () {
    if (visible && propVisible) {
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(true);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [propVisible, visible]);
  var triggerDom = useMemo(function () {
    if (!trigger) {
      return null;
    }

    return /*#__PURE__*/React.cloneElement(trigger, _objectSpread(_objectSpread({
      key: 'trigger'
    }, trigger.props), {}, {
      onClick: function () {
        var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
          var _trigger$props, _trigger$props$onClic;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setVisible(!visible);
                  (_trigger$props = trigger.props) === null || _trigger$props === void 0 ? void 0 : (_trigger$props$onClic = _trigger$props.onClick) === null || _trigger$props$onClic === void 0 ? void 0 : _trigger$props$onClic.call(_trigger$props, e);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onClick(_x) {
          return _onClick.apply(this, arguments);
        }

        return onClick;
      }()
    }));
  }, [setVisible, trigger, visible]);
  var submitterConfig = useMemo(function () {
    var _context$locale$Modal, _context$locale, _context$locale$Modal2, _context$locale$Modal3, _context$locale2, _context$locale2$Moda;

    if (rest.submitter === false) {
      return false;
    }

    return merge({
      searchConfig: {
        submitText: (_context$locale$Modal = (_context$locale = context.locale) === null || _context$locale === void 0 ? void 0 : (_context$locale$Modal2 = _context$locale.Modal) === null || _context$locale$Modal2 === void 0 ? void 0 : _context$locale$Modal2.okText) !== null && _context$locale$Modal !== void 0 ? _context$locale$Modal : '确认',
        resetText: (_context$locale$Modal3 = (_context$locale2 = context.locale) === null || _context$locale2 === void 0 ? void 0 : (_context$locale2$Moda = _context$locale2.Modal) === null || _context$locale2$Moda === void 0 ? void 0 : _context$locale2$Moda.cancelText) !== null && _context$locale$Modal3 !== void 0 ? _context$locale$Modal3 : '取消'
      },
      resetButtonProps: {
        preventDefault: true,
        // 提交表单loading时，不可关闭弹框
        disabled: submitTimeout ? loading : undefined,
        onClick: function onClick(e) {
          var _drawerProps$onClose;

          setVisible(false);
          drawerProps === null || drawerProps === void 0 ? void 0 : (_drawerProps$onClose = drawerProps.onClose) === null || _drawerProps$onClose === void 0 ? void 0 : _drawerProps$onClose.call(drawerProps, e);
        }
      }
    }, rest.submitter);
  }, [(_context$locale3 = context.locale) === null || _context$locale3 === void 0 ? void 0 : (_context$locale3$Moda = _context$locale3.Modal) === null || _context$locale3$Moda === void 0 ? void 0 : _context$locale3$Moda.cancelText, (_context$locale4 = context.locale) === null || _context$locale4 === void 0 ? void 0 : (_context$locale4$Moda = _context$locale4.Modal) === null || _context$locale4$Moda === void 0 ? void 0 : _context$locale4$Moda.okText, drawerProps, rest.submitter, setVisible, loading, submitTimeout]);
  var contentRender = useCallback(function (formDom, submitter) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, formDom, footerRef.current && submitter ? /*#__PURE__*/createPortal(submitter, footerRef.current) : submitter);
  }, []);
  var onFinishHandle = useRefFunction( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values) {
      var response, timer, result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              response = onFinish === null || onFinish === void 0 ? void 0 : onFinish(values);

              if (submitTimeout && response instanceof Promise) {
                setLoading(true);
                timer = setTimeout(function () {
                  return setLoading(false);
                }, submitTimeout);
                response.finally(function () {
                  clearTimeout(timer);
                  setLoading(false);
                });
              }

              _context2.next = 4;
              return response;

            case 4:
              result = _context2.sent;

              // 返回真值，关闭弹框
              if (result) {
                setVisible(false);
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Drawer, _extends({
    title: title,
    width: width || 800
  }, drawerProps, {
    visible: visible,
    onClose: function onClose(e) {
      var _drawerProps$onClose2;

      // 提交表单loading时，阻止弹框关闭
      if (submitTimeout && loading) return;
      setVisible(false);
      drawerProps === null || drawerProps === void 0 ? void 0 : (_drawerProps$onClose2 = drawerProps.onClose) === null || _drawerProps$onClose2 === void 0 ? void 0 : _drawerProps$onClose2.call(drawerProps, e);
    },
    footer: rest.submitter !== false && /*#__PURE__*/React.createElement("div", {
      ref: footerDomRef,
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    })
  }), /*#__PURE__*/React.createElement(BaseForm, _extends({
    formComponentType: "DrawerForm",
    layout: "vertical"
  }, rest, {
    submitter: submitterConfig,
    onFinish: onFinishHandle,
    contentRender: contentRender
  }), children)), triggerDom);
}

export { DrawerForm };